// src/components/store/sections/weekly-banner/WeeklyBannerV15RacingstripeSlateGold.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV15RacingstripeSlateGold(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={15}
      archKey="racing_stripe"
      archLabel="Diagonal Racing Banner"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      {...props}
    />
  );
}
